/**
 * Function names available inside template formulas whose single string
 * argument is a template field path (the existing `{{...}}` path syntax,
 * including array filters). Uppercase-only so they can never collide with
 * the lowercase scalar builtins (`min` vs `MIN`) — lookups are case
 * sensitive.
 *
 * Kept in a dependency-free module so both the template parser (static
 * validation) and the runtime scope builder can import it without cycles.
 */
export const FIELD_FUNCTION_NAME = 'FIELD';

export const TEMPLATE_AGGREGATE_FUNCTION_NAMES = [
  'SUM',
  'AVG',
  'COUNT',
  'MIN',
  'MAX',
] as const;

export type TemplateAggregateFunctionName =
  (typeof TEMPLATE_AGGREGATE_FUNCTION_NAMES)[number];

export const TEMPLATE_PATH_FUNCTION_NAMES: ReadonlySet<string> = new Set([
  FIELD_FUNCTION_NAME,
  ...TEMPLATE_AGGREGATE_FUNCTION_NAMES,
]);
